import { render, staticRenderFns } from "./Form12CaseInformation.vue?vue&type=template&id=192e4942&scoped=true"
import script from "./Form12CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form12CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192e4942",
  null
  
)

export default component.exports